import React from "react";
import { Modal, Button } from "react-bootstrap";
import styles from "../../styles/common/PickupModal.module.css";
import modalStyles from "../../styles/common/Modal.module.css";

interface PickupModalProps {
  show: boolean;
  onHide: () => void;
}

const PickupModal: React.FC<PickupModalProps> = ({ show, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      scrollable={true}
      className={styles.faqModal}
      contentClassName={styles.scaleIn}
      animation={false}
    >
      <Modal.Header closeButton>
        <Modal.Title as="h3" className={modalStyles.modalTitle}>Recogida de Pickup</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="faq-content">
          <h5>¿Qué es el servicio de Pickup?</h5>
          <p>
            Es nuestro servicio de recolección a domicilio. Si te encuentras en
            nuestra zona de cobertura, no necesitas trasladarte; nosotros vamos
            hasta tu casa u oficina para retirar tus paquetes.
          </p>

          <h5>Preparación del Paquete</h5>
          <p>
            Asegúrate de que tu paquete esté bien cerrado y tenga escrita la
            información del destinatario o tu número de casillero para agilizar
            el proceso al momento del retiro.
          </p>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="primary" onClick={onHide} className={modalStyles.closeBtn}>
          Entendido
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PickupModal;
